export default __webpack_public_path__ + "static/media/video-back-icon.75b0d779.svg";